import React from 'react';
import { Gift } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function BonusStack() {
  const bonuses = ['Recetas para bebés', 'Guía de berrinches', 'Guía de juguetes', 'Masajes para bebés', 'Guía de sueño', 'Introducción de alimentos', 'Primeros auxilios', 'Rutinas diarias'];
  return <section className="bg-brand-black text-white py-24 px-6 relative overflow-hidden" data-id="element-41">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#fff 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-42"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-43">
        <div className="text-center mb-16" data-id="element-44">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-gold text-white rounded-full mb-6 shadow-lg shadow-brand-gold/20" data-id="element-45">
            <Gift className="w-8 h-8" data-id="element-46" />
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif mb-4" data-id="element-47">
            Además, hoy recibís{' '}
            <span className="text-brand-gold" data-id="element-48">8 bonos GRATIS</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 mb-16" data-id="element-49">
          {bonuses.map((bonus, index) => <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-4 flex items-center justify-between border border-white/10 hover:bg-white/15 transition-colors" data-id="element-50">
              <div className="flex items-center gap-3" data-id="element-51">
                <div className="bg-brand-gold/20 text-brand-gold w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm" data-id="element-52">
                  {index + 1}
                </div>
                <span className="font-medium text-lg" data-id="element-53">{bonus}</span>
              </div>
              <div className="text-right flex flex-col" data-id="element-54">
                <span className="text-white/50 line-through text-xs" data-id="element-55">
                  $12.000
                </span>
                <span className="text-brand-gold font-bold text-sm" data-id="element-56">
                  GRATIS HOY
                </span>
              </div>
            </div>)}
        </div>

        {/* Value Stack Box */}
        <div className="bg-white rounded-3xl p-8 md:p-12 text-brand-black shadow-2xl max-w-2xl mx-auto transform hover:scale-[1.02] transition-transform duration-300 mb-12" data-id="element-57">
          <h3 className="text-2xl font-bold text-center mb-8 border-b pb-4" data-id="element-58">
            Resumen de Valor
          </h3>

          <div className="space-y-4 mb-8 text-lg" data-id="element-59">
            <div className="flex justify-between items-center" data-id="element-60">
              <span className="text-brand-charcoal" data-id="element-61">
                Sistema Completo (2 Ebooks)
              </span>
              <span className="font-medium" data-id="element-62">$42.000</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-63">
              <span className="text-brand-charcoal" data-id="element-64">8 Bonos Exclusivos</span>
              <span className="font-medium" data-id="element-65">$96.000</span>
            </div>
          </div>

          <div className="border-t-2 border-dashed border-brand-sage/30 pt-6" data-id="element-66">
            <div className="flex justify-between items-center" data-id="element-67">
              <span className="text-xl font-bold" data-id="element-68">VALOR TOTAL</span>
              <span className="text-3xl font-serif text-brand-red line-through decoration-2" data-id="element-69">
                $138.000
              </span>
            </div>
          </div>
        </div>

        <div className="text-center" data-id="element-70">
          <CTAButton data-id="element-71" />
          <p className="text-sm text-brand-gold font-bold mt-3" data-id="element-72">
            Todo por solo $19.990 — Oferta por tiempo limitado
          </p>
        </div>
      </div>
    </section>;
}